<template lang="pug">
  v-container(fluid)
    h2.text-center Rounds
    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12")
        v-expansion-panels
          v-expansion-panel
            v-expansion-panel-header {{ translations.filter.name }}
            v-expansion-panel-content
              v-container.pa-0(fluid)
                form
                  v-row
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseChipSelectField(:multiple="false", :items="providersListAll" v-model="roundParams.provider", :label="translations.filter.provider")
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseChipSelectField(:multiple="false", :items="operatorsListAll" v-model="roundParams.operator", :label="translations.filter.operator")
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseChipSelectField(:multiple="false", :items="gamesListAll" v-model="roundParams.game", :label="translations.filter.game")
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseDatePicker(v-model="roundParams.start", :label="translations.filter.start")
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseDatePicker(v-model="roundParams.end", :label="translations.filter.end")
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseTextField(v-model="roundParams.user" label="Usuario")
                    v-col.py-0.text-right(cols="12")
                      v-btn(@click="search" text color="primary")
                        v-icon.mr-2 mdi-magnify
                        | {{ translations.filter.send }}
      v-divider
    v-row.px-2.px-sm-10.pb-10( justify="center")
      v-col(cols="12").text-right
        v-tooltip(top)
          template(v-slot:activator="{ on, attrs }")
            v-btn(color="primary" @click="search" text v-bind="attrs" v-on="on")
              v-icon mdi-reload
          span Reload
      v-col(cols="12")
        v-progress-linear(color="primary", :active="isLoading" indeterminate)
        v-simple-table
          template(default)
            thead
              tr
                th(v-for="header in headers") {{header.text}}
            tbody(ref="roundData")
              tr(v-for="(round,i) in datos", :key="i")
                td
                  span.fantasy__block-width--13 {{ round.externalReference }}
                td {{ round.operator.n }}
                td {{ round.provider.n }}
                td
                  span.fantasy__block-width--8 {{ round.game.n }}
                td.text-right {{ currencyFormat(round.moneyIn, getCurrency(round.currency)) }}
                td.text-right {{ currencyFormat(round.moneyOut, getCurrency(round.currency)) }}
                td {{ round.user.un }}
                td
                  span.fantasy__block-width--8 {{ round.start }}
                td
                  BaseConfirmDialog(v-if="hasPermission('views.rounds.toggleRound')" @confirm="toggleState(round.id)" v-bind="translations.confirmationDialog.status")
                    template(v-slot="{ on }")
                      v-btn(v-on="on", :color="getColor(round.status)", :loading="loadingToggleRound" dark rounded) {{ round.status }}
                  v-chip(v-else :color="getColor(round.status)" text-color="white") {{ round.status }}
                td
                  TransactionInfoDialog(@emitTransactions="getTransactions", :roundId="round.id", :loading="loadingTransaction", :info="transactions")
                td
                  RoundInfoDialog(:info="round")
                td
                  LaunchDialog(@emitLaunch="getDetailRound", :roundId="round.id", :loading="loadingLaunch", :info="detailRound")
      pagination(@NextPage="nextPage()" @BackPage="backPage()" @changeLimit="changeLimit", :pagination="pagination")
</template>

<script>

  import LaunchDialog from "./components/LaunchDialog";
  import RoundInfoDialog from "./components/RoundInfoDialog";
  import Pagination from "@/components/pagination/pagination";
  import TransactionInfoDialog from "./components/TransactionsInfoDialog";
  import { currencyList } from '@/store/variablesGlobals.js';

  export default {
    name: "RoundsIndex",
    components: {
      TransactionInfoDialog,
      Pagination,
      RoundInfoDialog,
      LaunchDialog
    },
    data:() => ({
      currencyList,
      roundParams:{
        offset: 0,
        limit: 30,
        id: '',
        operator: null,
        provider: null,
        game: null,
        user: '',
        start: '',
        end: '',
      },
      isLoading: false,
      emptyField: {},
    }),
    computed: {
      translations(){
        return this.$t("views.roundsIndex");
      },
      headers(){
        return [
          {
            text: this.translations.tableHeadText.roundId,
            value: 'roundId'
          },
          {
            text: this.translations.tableHeadText.operator,
            value: 'operator'
          },
          {
            text: this.translations.tableHeadText.provider,
            value: 'provider'
          },
          {
            text: this.translations.tableHeadText.game,
            value: 'game'
          },
          {
            text: this.translations.tableHeadText.moneyIn,
            value: 'moneyIn',
            align: 'end'
          },
          {
            text: this.translations.tableHeadText.moneyOut,
            value: 'moneyOut',
            align: 'end'
          },
          {
            text: this.translations.tableHeadText.user,
            value: 'user'
          },
          {
            text: this.translations.tableHeadText.start,
            value: 'start',
          },
          {
            text: this.translations.tableHeadText.status,
            value: 'status'
          },
          {
            text: '',
            value: 'transactions',
            sortable: false
          },
          {
            text: '',
            value: 'info',
            sortable: false
          },
          {
            text: '',
            value: 'repro',
            sortable: false
          },
        ]
      },
      datos(){
        if(this.roundsListAll.docs != undefined) {
          return this.roundsListAll.docs.map(round => {
            return {
              id: round._id,
              operator: round.b,
              game: round.g,
              externalReference: round.er,
              provider: round.p,
              status: round.st,
              start: this.$moment(round.s).format('DD/MM/YYYY HH:mm'),
              moneyIn: round.min,
              moneyOut: round.mout,
              currency: round.c,
              transactions: round.txs,
              user: round.u
            }
          });
        } else {
          return [];
        }
      },
      pagination(){
        if(this.roundsListAll.docs != undefined) {
          return {
            hasPrevPage: this.roundsListAll.hasPrevPage,
            hasNextPage: this.roundsListAll.hasNextPage,
            limit: this.roundsListAll.limit,
            page: this.roundsListAll.page,
            pageCounter: this.roundsListAll.pagingCounter,
            totalPages: this.roundsListAll.totalPages
          };
        } else {
          return {};
        }
      },
      transactions(){
        return this.$store.state.casino.transactions.map(transaction => {
          return {
            id: transaction._id,
            transactionId: transaction.etx,
            provider: transaction.p,
            amount: transaction.a,
            bonusAmount: transaction.ba != null ? transaction.ba : 0,
            currency: transaction.c,
            externalReference:  transaction.er,
            operator: transaction.b,
            game: transaction.g,
            request: transaction.req,
            response: transaction.res,
            type: transaction.t,
            status: transaction.st,
            user: transaction.u,
            created: this.$moment(transaction.cat).format('DD/MM/YYYY HH:mm'),
            update: this.$moment(transaction.uat).format('DD/MM/YYYY HH:mm'),
          }
        });
      },
      detailRound(){
        return this.$store.state.casino.detailRound;
      },
      roundsListAll() {
        return this.$store.state.casino.rounds;
      },
      loadingChangePage(){
        return this.$store.state.statusCode.roundsTable.loading;
      },
      providersListAll() {
        return this.$store.state.providers.map(provider => ({
          text: provider.n,
          value: `${provider._id}`
        })).sort((a, b) => a.text.localeCompare(b.text))
      },
      operatorsListAll() {
        return this.$store.state.operators.map(operator => ({
          text: operator.n,
          value: operator._id
        })).sort((a, b) => a.text.localeCompare(b.text));
      },
      gamesListAll() {
        return this.$store.state.games.map(operator => ({
          text: operator.n,
          value: operator._id
        })).sort((a, b) => a.text.localeCompare(b.text));
      },
      loadingToggleRound(){
        return this.$store.state.statusCode.toggleRound.loading;
      },
      statusAsyncState(){
        return this.$store.state.statusCode.toggleRound.state || '';
      },
      loadingTransaction(){
        return this.$store.state.statusCode.getTransactions.loading;
      },
      loadingLaunch(){
        return this.$store.state.statusCode.detailRound.loading;
      },
    },
    watch: {
      statusAsyncState: function(val){
        if (val == 200){
          this.updateRounds();
        }
      },
      roundsListAll: function(val){
        if (val){
          this.isLoading = false;
          this.$refs.roundData.style.display = "table-row-group";
        }
      },
    },
    created(){
      let roundParams = {
        offset: 0,
        limit: 30,
        id: '',
        operator: '',
        provider: '',
        game: '',
        user: '',
        start: '',
        end: ''
      };
      this.$store.dispatch('getRounds',roundParams);
      this.$store.dispatch('getProviders');
      this.$store.dispatch('getOperators');
      this.$store.dispatch('getGames');
      /*this.$store.dispatch('getProviders');
      this.$store.dispatch('getAccountManagers');*/
    },

    methods:{
      getColor(type){
        return type == undefined || type == 'OPEN' ? 'green' : 'red';
      },
      getStatus(type){
        return type == undefined || type == 'OPEN' ? this.translations.status.enabled : this.translations.status.disabled;
      },
      updateRounds(){
        this.$store.dispatch('getRounds');
      },
      nextPage() {
        let offset = this.roundParams.offset + this.roundParams.limit;

        this.roundParams.offset = offset;

        this.search();
        this.TopscrollTo();
      },
      backPage() {
        let offset = this.roundParams.offset - this.roundParams.limit;

        this.roundParams.offset = offset;

        this.search();

        this.TopscrollTo();
      },
      changeLimit(limit){
        this.roundParams.limit = limit;
        this.search();
        this.TopscrollTo();
      },
      TopscrollTo() {
        if(window.scrollY != 0) {
          setTimeout(function() {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }, 100);
        }
      },
      search(){
        this.isLoading = true;
        this.$refs.roundData.style.display = "none";

        let filterParams = {
          offset: this.roundParams.offset,
          limit: this.roundParams.limit,
          id: this.roundParams.id,
          operator: this.roundParams.operator != null ? this.roundParams.operator.value : '',
          provider: this.roundParams.provider != null ? this.roundParams.provider.value : '',
          game: this.roundParams.game != null ? this.roundParams.game.value : '',
          user: this.roundParams.user,
          start: this.$moment(this.roundParams.start, "DD/MM/YYYY").format('YYYY-MM-DD'),
          end: this.$moment(this.roundParams.end, "DD/MM/YYYY").format('YYYY-MM-DD'),
        };
        this.$store.dispatch('getRounds', filterParams);
      },
      getTransactions(roundId){
        this.$store.dispatch('getTransactions',roundId);
      },
      toggleState(roundId){
        this.$store.dispatch('toggleRound', roundId);
      },
      getDetailRound(roundId){
        this.$store.dispatch('detailRound', roundId);
      },
      getCurrency(currentCurrency) {
        let curr = this.currencyList.find(item=> item.value === currentCurrency );
        return curr.text;
      }
    }
  }
</script>

<style lang="sass">
</style>